var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 767,
    height: 720,
    viewBox: "0 0 767 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197.132 172.754V163.845C197.123 157.732 194.692 151.872 190.371 147.548C186.05 143.224 180.192 140.788 174.079 140.775H167.788C161.672 140.784 155.809 143.217 151.485 147.542C147.16 151.867 144.727 157.729 144.718 163.845V172.754H142.609V219.949H199.24V172.754H197.132ZM158.318 163.845C158.323 161.335 159.322 158.929 161.097 157.154C162.872 155.379 165.278 154.38 167.788 154.376H174.079C176.586 154.385 178.987 155.386 180.759 157.16C182.53 158.935 183.527 161.338 183.531 163.845V172.754H158.318V163.845Z",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M175.576 193.155C175.578 192.356 175.373 191.57 174.982 190.872C174.591 190.175 174.026 189.591 173.343 189.176C172.66 188.761 171.881 188.529 171.082 188.504C170.283 188.479 169.49 188.66 168.782 189.031C168.074 189.402 167.473 189.949 167.039 190.62C166.604 191.291 166.35 192.063 166.302 192.861C166.253 193.659 166.411 194.456 166.761 195.175C167.111 195.894 167.641 196.51 168.299 196.964V209.987H173.586V196.964C174.202 196.538 174.706 195.969 175.052 195.306C175.399 194.642 175.578 193.904 175.576 193.155Z",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7773 109.186L150.312 68.9106",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M261.89 265.886L198.611 302.541",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M194.09 68.3157L261.942 107.35",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M145.584 301.572L80.7246 264.255",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5938 146.47L59.6958 226.869",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M286.084 226.529L285.965 146.776",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M117.602 218.3C123.342 227.558 131.353 235.196 140.875 240.49C150.396 245.783 161.112 248.556 172.005 248.545H172.685",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M228.008 153.662C222.538 143.74 214.53 135.45 204.804 129.64C195.077 123.829 183.982 120.708 172.652 120.594",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M172.652 248.528C183.339 248.413 193.826 245.618 203.153 240.399C212.479 235.18 220.347 227.705 226.036 218.657",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M228.007 153.662C233.523 163.681 236.25 174.997 235.903 186.429C235.556 197.861 232.148 208.991 226.035 218.657",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M115.646 154.206C110.31 164.118 107.681 175.263 108.024 186.515C108.367 197.768 111.671 208.731 117.601 218.3",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M115.646 154.206C121.124 144.037 129.252 135.541 139.169 129.62C149.086 123.7 160.421 120.575 171.971 120.577H172.651",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M150.311 68.9106C152.846 72.2534 156.121 74.9642 159.878 76.8311C163.636 78.6981 167.774 79.6705 171.97 79.6724H172.65",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M194.091 68.3157C191.636 71.7322 188.423 74.533 184.703 76.4976C180.983 78.4623 176.858 79.5374 172.652 79.6385",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M194.09 68.3155C197.022 64.2247 198.762 59.4005 199.116 54.3797C199.47 49.3588 198.423 44.3383 196.094 39.8766C193.764 35.415 190.242 31.6872 185.92 29.1081C181.597 26.529 176.644 25.1997 171.612 25.2681C166.579 25.3365 161.664 26.8 157.413 29.4956C153.162 32.1912 149.743 36.0133 147.535 40.5367C145.328 45.06 144.418 50.1071 144.909 55.1165C145.399 60.1258 147.269 64.901 150.312 68.9106",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M172.652 281.103C178.758 281.243 184.639 283.434 189.348 287.323C194.057 291.212 197.321 296.572 198.613 302.541",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M145.584 301.572C147.074 295.706 150.478 290.505 155.257 286.791C160.037 283.078 165.918 281.064 171.97 281.069H172.65",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M145.585 301.572C145.002 303.792 144.705 306.077 144.701 308.373C144.796 312.131 145.669 315.829 147.265 319.233C148.861 322.637 151.146 325.673 153.974 328.15C156.803 330.627 160.114 332.491 163.699 333.623C167.284 334.756 171.065 335.133 174.803 334.731C178.541 334.33 182.155 333.157 185.417 331.288C188.68 329.419 191.519 326.894 193.756 323.872C195.993 320.851 197.58 317.398 198.416 313.732C199.251 310.067 199.318 306.268 198.612 302.575",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M285.964 146.776H286.304C291.142 146.764 295.888 145.461 300.055 143.003C304.221 140.546 307.657 137.021 310.008 132.793C312.358 128.565 313.539 123.787 313.428 118.951C313.317 114.114 311.919 109.395 309.377 105.28C306.834 101.164 303.241 97.8007 298.966 95.5364C294.691 93.2721 289.89 92.1888 285.057 92.398C280.224 92.6073 275.534 94.1016 271.471 96.7269C267.408 99.3522 264.118 103.014 261.941 107.334",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M262.791 133.294C260.483 129.388 259.196 124.965 259.048 120.431C258.899 115.897 259.894 111.399 261.94 107.35",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M285.964 146.776C281.266 146.721 276.662 145.451 272.601 143.088C268.54 140.725 265.16 137.351 262.791 133.294",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5938 146.47C63.6827 145.863 67.5793 144.331 70.9878 141.992C74.3962 139.653 77.2266 136.568 79.2641 132.971",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7766 109.187C78.8939 104.639 75.8125 100.687 71.8608 97.7527C67.9092 94.8182 63.2354 93.0109 58.3375 92.5234C53.4396 92.0359 48.5012 92.8865 44.0487 94.9845C39.5961 97.0825 35.7963 100.349 33.054 104.437C30.3118 108.524 28.7301 113.279 28.4773 118.195C28.2245 123.11 29.3102 128.002 31.6187 132.349C33.9272 136.697 37.372 140.336 41.5858 142.88C45.7997 145.423 50.6248 146.776 55.5468 146.793C56.9019 146.789 58.2546 146.681 59.5931 146.47",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7748 109.187C82.3471 113.008 83.0281 117.138 82.7659 121.262C82.5037 125.386 81.3053 129.396 79.2617 132.988",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M286.082 226.529C281.349 226.572 276.71 227.85 272.622 230.235C268.534 232.62 265.14 236.031 262.773 240.13",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M286.083 226.529H286.304C291.145 226.543 295.895 227.849 300.063 230.311C304.231 232.774 307.666 236.305 310.014 240.538C312.362 244.772 313.537 249.556 313.419 254.395C313.301 259.235 311.893 263.955 309.341 268.069C306.789 272.183 303.186 275.542 298.902 277.798C294.619 280.054 289.811 281.126 284.975 280.904C280.139 280.681 275.45 279.172 271.392 276.532C267.334 273.892 264.054 270.217 261.891 265.887",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M262.774 240.062C260.484 243.951 259.203 248.351 259.049 252.862C258.895 257.372 259.871 261.85 261.89 265.887",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6946 226.869C58.3222 226.652 56.9356 226.539 55.5463 226.529C50.6297 226.546 45.8096 227.895 41.5987 230.434C37.3879 232.972 33.9437 236.604 31.6324 240.943C29.3212 245.283 28.2293 250.168 28.4729 255.078C28.7165 259.989 30.2865 264.742 33.0159 268.831C35.7453 272.921 39.532 276.194 43.9734 278.303C48.4148 280.412 53.3447 281.278 58.2389 280.808C63.1331 280.339 67.8086 278.551 71.768 275.637C75.7275 272.722 78.8229 268.788 80.7251 264.254",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6953 226.869C63.8213 227.496 67.7476 229.065 71.1704 231.453C74.5931 233.84 77.4205 236.984 79.4337 240.64",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7237 264.254C82.2997 260.475 83.0021 256.388 82.7783 252.299C82.5546 248.21 81.4106 244.225 79.4316 240.64",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M172.652 281.103V248.528",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M172.652 79.6384V120.594",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M262.775 240.062L226.104 218.657",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M115.644 154.206L79.2617 132.971",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M117.599 218.3L79.4316 240.64",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M262.79 133.294L228.006 153.662",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M286.304 119.523L284.723 120.458",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M174.657 425.987V378.094L133.157 354.14L91.6738 378.094V425.987L133.157 449.942L174.657 425.987Z",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M216.515 497.936V450.026L175.032 426.072L133.549 450.026V497.936L175.032 521.891L216.515 497.936Z",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M175.151 569.664V521.755L133.668 497.8L92.168 521.755V569.664L133.668 593.619L175.151 569.664Z",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M150.414 394.722V389.179C150.41 385.378 148.899 381.733 146.212 379.044C143.526 376.354 139.883 374.839 136.082 374.83H132.155C128.354 374.839 124.711 376.354 122.024 379.044C119.338 381.733 117.827 385.378 117.823 389.179V394.722H116.514V424.066H151.723V394.722H150.414ZM126.289 389.179C126.289 387.622 126.907 386.128 128.006 385.026C129.106 383.923 130.598 383.301 132.155 383.297H136.082C137.639 383.301 139.131 383.923 140.231 385.026C141.33 386.128 141.947 387.622 141.947 389.179V394.722H126.289V389.179Z",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M137.015 407.371C137.016 406.872 136.888 406.382 136.643 405.948C136.399 405.514 136.047 405.15 135.621 404.893C135.194 404.635 134.709 404.491 134.211 404.477C133.713 404.462 133.219 404.576 132.778 404.808C132.338 405.04 131.964 405.382 131.695 405.801C131.425 406.22 131.268 406.701 131.239 407.198C131.21 407.696 131.311 408.192 131.53 408.639C131.75 409.087 132.081 409.469 132.492 409.751V417.843H135.757V409.751C136.145 409.487 136.462 409.132 136.682 408.717C136.901 408.302 137.015 407.84 137.015 407.371Z",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M190.094 466.96V461.417C190.089 457.618 188.578 453.975 185.891 451.288C183.204 448.601 179.561 447.09 175.762 447.085H171.851C168.05 447.09 164.406 448.601 161.716 451.287C159.027 453.973 157.511 457.616 157.502 461.417V466.96H156.193V496.304H191.403V466.96H190.094ZM165.969 461.417C165.969 459.857 166.589 458.361 167.692 457.258C168.795 456.155 170.291 455.535 171.851 455.535H175.762C177.32 455.539 178.814 456.161 179.916 457.263C181.018 458.365 181.64 459.859 181.644 461.417V466.96H165.969V461.417Z",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M176.731 479.694C176.735 479.195 176.61 478.703 176.368 478.267C176.125 477.831 175.774 477.465 175.348 477.205C174.923 476.945 174.437 476.8 173.938 476.783C173.439 476.766 172.945 476.879 172.503 477.11C172.061 477.341 171.686 477.683 171.415 478.102C171.144 478.52 170.986 479.002 170.956 479.5C170.927 479.998 171.027 480.495 171.246 480.943C171.466 481.391 171.797 481.775 172.209 482.057V490.149H175.49V482.057C175.874 481.794 176.188 481.441 176.404 481.029C176.62 480.617 176.733 480.159 176.731 479.694Z",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M150.072 538.705V533.179C150.068 529.378 148.557 525.733 145.871 523.044C143.184 520.354 139.542 518.839 135.74 518.83H131.83C128.026 518.835 124.379 520.348 121.689 523.038C118.999 525.728 117.485 529.375 117.481 533.179V538.722H116.172V568.066H151.398V538.705H150.072ZM125.948 533.179C125.948 531.619 126.567 530.123 127.67 529.02C128.774 527.917 130.27 527.297 131.83 527.297H135.74C137.3 527.297 138.797 527.917 139.9 529.02C141.003 530.123 141.623 531.619 141.623 533.179V538.722H125.948V533.179Z",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M136.677 551.422C136.678 550.923 136.55 550.434 136.306 549.999C136.061 549.565 135.709 549.201 135.283 548.944C134.856 548.686 134.371 548.542 133.873 548.528C133.375 548.513 132.881 548.627 132.441 548.859C132 549.091 131.626 549.433 131.357 549.852C131.087 550.271 130.93 550.752 130.901 551.25C130.873 551.747 130.973 552.243 131.192 552.69C131.412 553.138 131.743 553.52 132.155 553.802V561.894H135.436V553.802C135.819 553.534 136.131 553.178 136.348 552.764C136.564 552.349 136.677 551.889 136.677 551.422Z",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6795 442.053L44.2405 441.067C43.6115 440.302 42.9314 439.571 42.2514 438.891C30.3505 433.467 18.5347 437.191 14.3694 438.891C13.9444 439.316 13.5194 439.775 13.1113 440.234L13.7574 441.543C13.9274 441.475 29.4495 433.926 43.6795 442.053Z",
    fill: "#263238"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6668 452.9C50.1867 451.389 49.6191 449.907 48.9666 448.462C43.5354 444.136 36.8174 441.743 29.8743 441.662C20.8127 441.662 11.921 446.337 7.51772 449.057C7.00769 450.191 6.54865 451.364 6.14062 452.577C7.60273 451.54 18.8405 443.838 29.9423 443.838C37.7736 444.014 45.2199 447.27 50.6668 452.9Z",
    fill: "#263238"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92919 482.788C8.92919 482.669 3.4038 470.887 10.4593 459.836C12.1897 457.04 14.491 454.64 17.2127 452.795C19.9344 450.949 23.0152 449.699 26.2534 449.126C32.3398 448.02 37.5592 449.347 39.8544 451.047C43.1369 453.72 46.0422 456.825 48.491 460.278C49.8447 462.161 51.3577 463.925 53.0133 465.549C53.0133 464.376 52.8603 463.237 52.7243 462.148C51.9252 461.213 51.0242 460.142 50.2081 459.003C47.6519 455.388 44.6082 452.145 41.1635 449.364C38.4263 447.323 32.6629 445.81 25.8624 447.034C22.3289 447.659 18.967 449.022 15.9963 451.035C13.0257 453.047 10.5132 455.664 8.62317 458.714C0.921628 470.819 6.71904 483.264 6.92305 483.774L8.92919 482.788Z",
    fill: "#263238"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4116 468.184C49.5104 466.987 48.6816 465.739 47.9295 464.443C44.7672 459.343 40.823 452.832 29.2282 452.832C26.8355 452.723 24.4487 453.15 22.2425 454.083C20.0363 455.015 18.0665 456.429 16.4773 458.221C12.0909 463.321 11.3769 470.717 12.1589 475.953C12.515 478.144 12.3017 480.389 11.5395 482.473C10.7773 484.557 9.49183 486.41 7.80664 487.854C8.124 488.511 8.46402 489.158 8.82671 489.792C10.8896 488.129 12.4806 485.954 13.4411 483.484C14.4016 481.014 14.6981 478.335 14.3011 475.715C13.587 470.955 14.2161 464.273 18.1264 459.734C19.5069 458.152 21.2269 456.902 23.1581 456.078C25.0893 455.253 27.1817 454.876 29.2792 454.974C39.5989 454.974 42.8801 460.346 46.0593 465.548C46.8641 466.92 47.7497 468.243 48.7115 469.51C49.8252 470.95 51.2117 472.158 52.7918 473.063C52.7918 472.264 52.9448 471.363 52.9788 470.615C52.0135 469.929 51.1493 469.11 50.4116 468.184Z",
    fill: "#263238"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M42.422 468.337C41.9711 467.39 41.4659 466.471 40.9089 465.583C38.8518 462.489 34.0064 455.246 24.1117 459.309C16.3422 462.523 17.0732 470.683 17.7363 477.875C17.9233 479.966 18.1103 481.938 18.1103 483.791C18.1103 488.891 14.4381 492.428 11.9219 494.213C12.3979 494.808 12.8739 495.352 13.367 495.913C16.1722 493.822 20.3205 489.826 20.3205 483.876C20.3205 481.921 20.1334 479.813 19.9464 477.773C19.3004 470.683 18.6883 464.002 25.0468 461.417C33.2924 458.017 36.9476 463.56 39.2088 466.875C39.5998 467.487 40.0589 468.388 40.5859 469.425C42.7917 474.546 46.3687 478.958 50.9226 482.176C51.1436 481.445 51.3476 480.697 51.5347 479.949C47.5338 476.942 44.3917 472.938 42.422 468.337Z",
    fill: "#263238"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7216 477.687C39.578 476.385 38.7104 474.864 38.1714 473.216C37.2068 470.327 35.4374 467.773 33.0711 465.855C32.2621 465.157 31.2619 464.719 30.2006 464.598C29.1394 464.477 28.0662 464.678 27.1207 465.175C23.9754 466.875 22.0203 471.584 22.3263 476.412C22.8024 482.465 36.1993 493.159 41.8437 497.409C42.3707 496.916 42.8808 496.372 43.3738 495.828C36.8283 490.897 24.8595 480.986 24.5025 476.242C24.1965 472.315 25.7606 468.371 28.1577 467.096C28.7413 466.783 29.4089 466.662 30.0652 466.75C30.7216 466.839 31.3332 467.132 31.813 467.589C33.8475 469.286 35.357 471.526 36.1653 474.049C36.8172 475.937 37.8469 477.673 39.1915 479.15C42.3356 481.944 45.6517 484.539 49.1202 486.919C49.4262 486.239 49.7323 485.576 50.0043 484.862C46.7636 482.666 43.6633 480.27 40.7216 477.687Z",
    fill: "#263238"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8203 471.584C29.2793 479.082 41.1632 489.928 45.3625 493.55C45.7875 492.972 46.2125 492.359 46.6036 491.747C41.2482 487.123 31.3025 477.415 30.9965 471.448L28.8203 471.584Z",
    fill: "#263238"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6764 492.988C30.0783 491.118 28.8032 489.588 26.5761 489.588C23.1758 489.588 18.0755 495.216 15.6953 498.089C16.2393 498.559 16.8067 499.002 17.3954 499.415C20.4046 495.828 24.6039 491.696 26.5421 491.696C27.6812 491.696 28.4632 492.529 29.9423 494.28C31.9728 496.774 34.3892 498.926 37.0998 500.656C37.8067 500.26 38.4932 499.829 39.157 499.364C36.3058 497.698 33.773 495.539 31.6764 492.988Z",
    fill: "#263238"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4098 502.373C31.8456 500.027 29.2615 496.542 27.4083 496.083C25.1982 495.522 23.243 498.956 22.002 501.931C22.699 502.186 23.396 502.407 24.1101 502.594C24.654 500.919 25.6064 499.406 26.8813 498.191C27.6634 498.378 29.4485 500.486 31.1146 502.883C31.8903 502.766 32.6572 502.595 33.4098 502.373Z",
    fill: "#263238"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6445 456.3H111.803",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6445 465.651H111.803",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6445 475.018H111.803",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6445 484.386H111.803",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M633.212 92.8482H635.865C636.802 92.8482 637.731 93.0329 638.597 93.3918C639.463 93.7506 640.251 94.2766 640.914 94.9396C641.577 95.6027 642.103 96.3898 642.462 97.2562C642.82 98.1225 643.005 99.051 643.005 99.9887V183.635H626.004V99.9887C626.004 99.0453 626.191 98.1112 626.554 97.2404C626.917 96.3696 627.449 95.5794 628.119 94.9154C628.79 94.2515 629.585 93.7269 630.459 93.3721C631.333 93.0173 632.269 92.8392 633.212 92.8482Z",
    fill: "#41525B",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M634.81 92.8482H637.462C638.4 92.8482 639.328 93.0329 640.195 93.3918C641.061 93.7506 641.848 94.2766 642.511 94.9396C643.174 95.6027 643.7 96.3898 644.059 97.2562C644.418 98.1225 644.603 99.051 644.603 99.9887V183.635H627.602V99.9887C627.602 99.0453 627.788 98.1112 628.152 97.2404C628.515 96.3696 629.047 95.5794 629.717 94.9154C630.387 94.2515 631.182 93.7269 632.057 93.3721C632.931 93.0173 633.867 92.8392 634.81 92.8482Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M591.049 171.564L620.461 153.764L628.366 147.456C628.366 147.456 632.481 137.596 630.067 128.755C627.652 119.914 625.136 120.118 625.136 120.118L597.934 132.665C597.934 132.665 607.115 158.864 591.049 171.564Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M577.247 131.22L592.259 127.514C584.557 112.213 568.678 104.426 556.318 110.206C545.489 115.307 540.881 129.044 544.503 142.985L577.247 131.22Z",
    fill: "#41525B",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M591.041 171.563C603.674 165.661 607.842 147.877 600.351 131.842C592.86 115.806 576.546 107.591 563.913 113.492C551.28 119.394 547.112 137.177 554.603 153.213C562.094 169.249 578.408 177.464 591.041 171.563Z",
    fill: "#37474F",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M583.892 140.452C587.139 147.405 585.32 155.124 579.846 157.691C574.371 160.258 567.282 156.688 564.035 149.734C560.787 142.781 562.589 135.045 568.081 132.495C573.572 129.945 580.645 133.447 583.892 140.452Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M651.864 100.941C644.724 85.6398 629.559 77.4792 617.216 81.8655V81.6615L561.214 108.149L551.744 112.672C560.223 110.303 569.269 111.031 577.26 114.726C585.251 118.421 591.665 124.841 595.352 132.835C595.352 133.005 595.522 133.192 595.59 133.362C595.862 133.982 596.255 134.542 596.746 135.009C597.237 135.475 597.816 135.839 598.449 136.08C599.082 136.32 599.756 136.433 600.433 136.41C601.11 136.387 601.775 136.229 602.391 135.946L621.857 127.276C621.857 127.276 628.573 141.506 620.531 153.73L640.932 141.302C641.476 141.098 642.021 140.877 642.548 140.622C655.196 134.756 659.362 116.973 651.864 100.941Z",
    fill: "#41525B",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M651.353 92.8481H654.005C654.943 92.8481 655.872 93.0328 656.738 93.3917C657.604 93.7505 658.391 94.2765 659.054 94.9395C659.718 95.6026 660.243 96.3898 660.602 97.2561C660.961 98.1224 661.146 99.0509 661.146 99.9886V183.635H644.264V99.9886C644.264 98.1037 645.009 96.2951 646.337 94.9575C647.665 93.6198 649.468 92.8616 651.353 92.8481Z",
    fill: "#41525B",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M652.953 92.8482H655.605C656.543 92.8482 657.471 93.0329 658.337 93.3918C659.204 93.7506 659.991 94.2766 660.654 94.9396C661.317 95.6027 661.843 96.3898 662.202 97.2562C662.561 98.1225 662.745 99.051 662.745 99.9887V183.635H645.744V99.9887C645.744 99.0453 645.931 98.1112 646.294 97.2404C646.657 96.3696 647.189 95.5794 647.86 94.9154C648.53 94.2515 649.325 93.7269 650.199 93.3721C651.073 93.0173 652.009 92.8392 652.953 92.8482Z",
    fill: "#41525B",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M602.577 182.411H675.376C676.052 182.411 676.701 182.679 677.179 183.158C677.657 183.636 677.926 184.284 677.926 184.961V188.463H600.061V184.961C600.06 184.29 600.325 183.647 600.795 183.169C601.266 182.692 601.906 182.42 602.577 182.411Z",
    fill: "#41525B",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M588.619 186.848H689.317C689.993 186.848 690.642 187.117 691.12 187.595C691.598 188.073 691.867 188.722 691.867 189.398V192.9H586.068V189.398C586.068 188.722 586.337 188.073 586.815 187.595C587.294 187.117 587.942 186.848 588.619 186.848Z",
    fill: "#41525B",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M465.365 153.859C494.019 146.996 511.684 118.204 504.82 89.5498C497.957 60.896 469.165 43.2313 440.511 50.0946C411.857 56.9579 394.193 85.7502 401.056 114.404C407.919 143.058 436.712 160.722 465.365 153.859Z",
    fill: "url(#paint0_linear_2157_4693)",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M470.522 88.0601C472.83 78.3301 466.812 68.572 457.082 66.2647C447.352 63.9575 437.594 69.9748 435.287 79.7048C432.98 89.4348 438.997 99.1929 448.727 101.5C458.457 103.807 468.215 97.7901 470.522 88.0601Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M482.003 135.64C482.003 127.93 478.941 120.535 473.488 115.083C468.036 109.631 460.642 106.568 452.931 106.568C445.221 106.568 437.826 109.631 432.374 115.083C426.922 120.535 423.859 127.93 423.859 135.64H482.003Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M503.715 111.209L534.742 124.147",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M614.224 640.848L561.435 555.842L455.331 557.746L506.419 640.967C508.459 644.283 509.237 648.222 508.613 652.064C507.988 655.906 506.003 659.396 503.019 661.896L490.965 662.746H350.604V665.789H600.402C603.316 665.799 606.179 665.026 608.692 663.551C611.205 662.076 613.275 659.954 614.688 657.405C616.1 654.857 616.802 651.976 616.721 649.063C616.639 646.151 615.777 643.314 614.224 640.848Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M555.435 557.593L608.223 642.599C609.763 645.064 610.614 647.896 610.689 650.801C610.763 653.705 610.059 656.577 608.648 659.118C607.237 661.658 605.172 663.774 602.666 665.247C600.161 666.719 597.307 667.493 594.401 667.489H486.563C489.456 667.488 492.296 666.715 494.792 665.251C497.287 663.786 499.346 661.683 500.758 659.157C502.17 656.632 502.883 653.776 502.823 650.883C502.763 647.991 501.933 645.166 500.419 642.701L449.33 559.48L555.435 557.593Z",
    fill: "#41525B",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M552.458 552.799L446.354 554.686L466.007 586.699H573.505L552.458 552.799Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M268.556 574.747H709.652C712.385 574.747 714.6 572.532 714.6 569.8V198.817C714.6 196.085 712.385 193.87 709.652 193.87L268.556 193.87C265.824 193.87 263.609 196.085 263.609 198.817L263.609 569.8C263.609 572.532 265.824 574.747 268.556 574.747Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M261.959 574.747H682.144C690.651 574.747 697.547 567.851 697.547 559.344V209.273C697.547 200.766 690.651 193.87 682.144 193.87L261.959 193.87C253.452 193.87 246.556 200.766 246.556 209.273L246.556 559.344C246.556 567.851 253.452 574.747 261.959 574.747Z",
    fill: "#41525B",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M261.278 193.87H682.908C686.81 193.874 690.55 195.427 693.308 198.188C696.065 200.949 697.614 204.691 697.614 208.593V506.539H246.572V208.593C246.572 204.691 248.121 200.949 250.879 198.188C253.636 195.427 257.376 193.874 261.278 193.87Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M265.512 485.678L678.607 485.678V209.018L265.512 209.018L265.512 485.678Z",
    fill: "#41525B",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M266.277 339.366H678.828",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M283.619 331.528C283.619 332.349 283.375 333.152 282.919 333.835C282.462 334.517 281.813 335.049 281.054 335.362C280.295 335.676 279.46 335.757 278.655 335.596C277.85 335.434 277.111 335.037 276.531 334.455C275.952 333.874 275.558 333.133 275.4 332.327C275.242 331.521 275.326 330.687 275.643 329.929C275.96 329.171 276.494 328.525 277.178 328.071C277.863 327.617 278.666 327.377 279.488 327.38C280.032 327.38 280.57 327.487 281.072 327.696C281.575 327.905 282.031 328.211 282.415 328.596C282.799 328.981 283.103 329.439 283.309 329.942C283.516 330.445 283.621 330.984 283.619 331.528Z",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M297.815 335.66C300.097 335.66 301.946 333.81 301.946 331.528C301.946 329.247 300.097 327.397 297.815 327.397C295.533 327.397 293.684 329.247 293.684 331.528C293.684 333.81 295.533 335.66 297.815 335.66Z",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M316.141 335.66C318.423 335.66 320.272 333.81 320.272 331.528C320.272 329.247 318.423 327.397 316.141 327.397C313.859 327.397 312.01 329.247 312.01 331.528C312.01 333.81 313.859 335.66 316.141 335.66Z",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M338.6 331.528C338.597 332.345 338.352 333.142 337.896 333.819C337.44 334.496 336.794 335.023 336.038 335.333C335.283 335.643 334.453 335.722 333.653 335.561C332.853 335.4 332.118 335.005 331.542 334.426C330.966 333.848 330.574 333.112 330.416 332.311C330.258 331.51 330.341 330.68 330.654 329.926C330.967 329.172 331.497 328.528 332.176 328.075C332.855 327.622 333.653 327.38 334.469 327.38C335.013 327.38 335.552 327.487 336.054 327.696C336.556 327.905 337.013 328.211 337.396 328.596C337.78 328.981 338.084 329.439 338.291 329.942C338.497 330.445 338.603 330.984 338.6 331.528Z",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M356.945 331.528C356.945 332.349 356.702 333.151 356.246 333.833C355.79 334.515 355.142 335.047 354.384 335.361C353.626 335.675 352.792 335.757 351.987 335.597C351.183 335.437 350.444 335.042 349.863 334.462C349.283 333.881 348.888 333.142 348.728 332.338C348.568 331.533 348.65 330.699 348.964 329.941C349.278 329.183 349.81 328.535 350.492 328.079C351.174 327.623 351.976 327.38 352.797 327.38C353.342 327.378 353.883 327.483 354.387 327.691C354.891 327.899 355.349 328.204 355.735 328.59C356.121 328.976 356.426 329.434 356.634 329.938C356.841 330.442 356.947 330.983 356.945 331.528Z",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M578.657 331.528C578.674 332.354 578.444 333.167 577.996 333.861C577.548 334.555 576.903 335.1 576.144 335.426C575.385 335.751 574.545 335.843 573.734 335.688C572.922 335.534 572.175 335.14 571.589 334.558C571.002 333.977 570.602 333.233 570.441 332.423C570.28 331.612 570.364 330.772 570.683 330.01C571.003 329.248 571.542 328.599 572.233 328.145C572.923 327.692 573.734 327.455 574.56 327.465C575.638 327.474 576.67 327.904 577.435 328.663C578.201 329.422 578.639 330.45 578.657 331.528Z",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M596.986 331.528C596.986 332.349 596.742 333.152 596.286 333.835C595.829 334.517 595.18 335.049 594.421 335.362C593.662 335.676 592.827 335.757 592.022 335.596C591.217 335.434 590.478 335.037 589.898 334.455C589.319 333.874 588.925 333.133 588.767 332.327C588.609 331.521 588.694 330.687 589.01 329.929C589.327 329.171 589.861 328.525 590.545 328.071C591.23 327.617 592.034 327.377 592.855 327.38C593.399 327.38 593.937 327.487 594.44 327.696C594.942 327.905 595.398 328.211 595.782 328.596C596.166 328.981 596.47 329.439 596.676 329.942C596.883 330.445 596.988 330.984 596.986 331.528Z",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M615.364 331.528C615.361 332.345 615.116 333.142 614.66 333.819C614.204 334.496 613.557 335.023 612.802 335.333C612.047 335.643 611.217 335.722 610.417 335.561C609.616 335.4 608.882 335.005 608.306 334.426C607.73 333.848 607.338 333.112 607.18 332.311C607.022 331.51 607.105 330.68 607.418 329.926C607.731 329.172 608.26 328.528 608.939 328.075C609.618 327.622 610.416 327.38 611.233 327.38C611.777 327.38 612.315 327.487 612.818 327.696C613.32 327.905 613.776 328.211 614.16 328.596C614.544 328.981 614.848 329.439 615.055 329.942C615.261 330.445 615.366 330.984 615.364 331.528Z",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M633.656 331.528C633.656 332.349 633.413 333.151 632.957 333.833C632.501 334.515 631.853 335.047 631.095 335.361C630.337 335.675 629.503 335.757 628.698 335.597C627.894 335.437 627.155 335.042 626.574 334.462C625.994 333.881 625.599 333.142 625.439 332.338C625.279 331.533 625.361 330.699 625.675 329.941C625.989 329.183 626.521 328.535 627.203 328.079C627.885 327.623 628.687 327.38 629.508 327.38C630.053 327.378 630.594 327.483 631.098 327.691C631.602 327.899 632.06 328.204 632.446 328.59C632.832 328.976 633.137 329.434 633.345 329.938C633.552 330.442 633.658 330.983 633.656 331.528Z",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M647.836 335.66C650.118 335.66 651.968 333.81 651.968 331.528C651.968 329.247 650.118 327.397 647.836 327.397C645.555 327.397 643.705 329.247 643.705 331.528C643.705 333.81 645.555 335.66 647.836 335.66Z",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M666.163 335.66C668.444 335.66 670.294 333.81 670.294 331.528C670.294 329.247 668.444 327.397 666.163 327.397C663.881 327.397 662.031 329.247 662.031 331.528C662.031 333.81 663.881 335.66 666.163 335.66Z",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M561.537 435.712H359.784C356.967 435.712 354.684 437.995 354.684 440.812V461.213C354.684 464.03 356.967 466.314 359.784 466.314H561.537C564.354 466.314 566.638 464.03 566.638 461.213V440.812C566.638 437.995 564.354 435.712 561.537 435.712Z",
    fill: "url(#paint1_linear_2157_4693)",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M404.328 449.874L403.699 445.946H405.841L405.229 449.874L408.783 448.088L409.446 450.112L405.535 450.775L408.323 453.563L406.623 454.821L404.787 451.302L402.951 454.821L401.251 453.563L404.022 450.775L400.129 450.112L400.792 448.088L404.328 449.874Z",
    fill: "#263238"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M417.436 449.874L416.824 445.946H418.966L418.337 449.874L421.89 448.088L422.553 450.112L418.66 450.775L421.431 453.563L419.731 454.821L417.895 451.302L416.059 454.821L414.358 453.563L417.147 450.775L413.236 450.112L413.899 448.088L417.436 449.874Z",
    fill: "#263238"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M430.542 449.874L429.93 445.946H432.072L431.46 449.874L434.997 448.088L435.677 450.112L431.766 450.775L434.555 453.563L432.854 454.821L431.018 451.302L429.182 454.821L427.482 453.563L430.27 450.775L426.377 450.112L427.04 448.088L430.542 449.874Z",
    fill: "#263238"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M443.651 449.874L443.022 445.946H445.181L444.552 449.874L448.105 448.088L448.768 450.112L444.858 450.775L447.646 453.563L445.946 454.821L444.11 451.302L442.291 454.821L440.591 453.563L443.379 450.775L439.469 450.112L440.132 448.088L443.651 449.874Z",
    fill: "#263238"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M456.776 449.874L456.164 445.946H458.306L457.677 449.874L461.23 448.088L461.893 450.112L458 450.775L460.788 453.563L459.088 454.821L457.252 451.268L455.416 454.787L453.716 453.529L456.504 450.741L452.594 450.078L453.274 448.054L456.776 449.874Z",
    fill: "#263238"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M469.902 449.874L469.273 445.946H471.415L470.854 449.874L474.408 448.088L475.071 450.112L471.16 450.775L473.948 453.563L472.248 454.821L470.412 451.302L468.576 454.821L466.876 453.563L469.647 450.775L465.754 450.112L466.417 448.088L469.902 449.874Z",
    fill: "#263238"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M483.01 449.874L482.398 445.946H484.54L483.911 449.874L487.464 448.088L488.127 450.112L484.234 450.775L487.005 453.563L485.305 454.821L483.469 451.302L481.633 454.821L479.933 453.563L482.721 450.775L478.811 450.112L479.474 448.088L483.01 449.874Z",
    fill: "#263238"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M496.116 449.874L495.504 445.946H497.647L497.035 449.874L500.571 448.088L501.251 450.112L497.341 450.775L500.129 453.563L498.429 454.821L496.593 451.302L494.756 454.821L493.056 453.563L495.844 450.775L491.951 450.112L492.614 448.088L496.116 449.874Z",
    fill: "#263238"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M509.241 449.874L508.612 445.946H510.754L510.142 449.874L513.695 448.088L514.358 450.112L510.448 450.775L513.236 453.563L511.536 454.821L509.7 451.302L507.881 454.821L506.181 453.563L508.969 450.775L505.059 450.112L505.722 448.088L509.241 449.874Z",
    fill: "#263238"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M522.35 449.874L521.738 445.946H523.88L523.251 449.874L526.805 448.088L527.468 450.112L523.574 450.775L526.363 453.563L524.662 454.821L522.826 451.302L520.99 454.821L519.29 453.563L522.078 450.775L518.168 450.112L518.848 448.088L522.35 449.874Z",
    fill: "#263238"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M534.366 396.568C573.983 356.951 573.983 292.719 534.366 253.101C494.749 213.484 430.516 213.484 390.899 253.101C351.282 292.719 351.282 356.951 390.899 396.568C430.516 436.185 494.749 436.185 534.366 396.568Z",
    fill: "url(#paint2_linear_2157_4693)",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M511.655 373.859C538.73 346.784 538.73 302.886 511.655 275.81C484.58 248.735 440.682 248.735 413.606 275.81C386.531 302.886 386.531 346.784 413.606 373.859C440.682 400.934 484.58 400.934 511.655 373.859Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M482.212 389.157C517.734 374.863 534.943 334.478 520.648 298.956C506.354 263.434 465.97 246.225 430.448 260.519C394.925 274.814 377.717 315.198 392.011 350.72C406.305 386.242 446.689 403.451 482.212 389.157Z",
    fill: "#41525B",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M491.164 359.347C510.225 340.286 510.225 309.38 491.164 290.319C472.102 271.257 441.197 271.257 422.135 290.319C403.074 309.38 403.074 340.286 422.135 359.347C441.197 378.409 472.102 378.409 491.164 359.347Z",
    fill: "url(#paint3_linear_2157_4693)",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M372.246 289.076L373.419 286.492L387.496 292.902L389.434 288.668L391.78 289.722L388.669 296.523L372.246 289.076Z",
    fill: "#263238"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M380.271 282.157C379.77 281.873 379.331 281.491 378.98 281.034C378.63 280.577 378.374 280.054 378.23 279.496C378.085 278.939 378.054 278.358 378.138 277.788C378.222 277.218 378.42 276.671 378.719 276.179C379.019 275.687 379.414 275.26 379.882 274.924C380.349 274.587 380.88 274.348 381.441 274.221C382.003 274.094 382.585 274.08 383.152 274.182C383.719 274.283 384.259 274.498 384.742 274.812L392.749 279.675C393.279 279.945 393.746 280.321 394.123 280.78C394.5 281.239 394.778 281.771 394.941 282.342C395.103 282.913 395.145 283.512 395.065 284.101C394.986 284.689 394.785 285.255 394.477 285.763C394.169 286.27 393.759 286.709 393.273 287.051C392.788 287.393 392.237 287.631 391.655 287.751C391.073 287.87 390.473 287.869 389.892 287.746C389.311 287.623 388.762 287.381 388.278 287.036L380.271 282.157ZM389.91 284.707C391.015 285.37 391.729 285.149 392.188 284.367C392.647 283.585 392.528 282.854 391.44 282.191L383.11 277.09C382.005 276.41 381.291 276.648 380.832 277.414C380.373 278.179 380.492 278.927 381.58 279.59L389.91 284.707Z",
    fill: "#263238"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M393.685 269.916L400.383 276.886L397.884 279.862L382.787 269.78L384.487 267.672L396.388 275.679L386.374 265.479L388.074 263.405L399.975 271.531L390.03 261.16L391.628 259.256L404.141 272.415L401.709 275.288L393.685 269.916Z",
    fill: "#263238"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M439.349 246.301L438.125 233.397L441.951 232.445L446.32 249.957L443.719 250.603L440.574 238.056L441.815 251.079L439.213 251.725L434.113 239.824L437.19 252.201L434.793 252.813L430.424 235.302L434.249 234.349L439.349 246.301Z",
    fill: "#263238"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M449.533 239.212L453.409 238.821L453.664 241.388L449.788 241.779L450.315 247.032L455.195 246.556L455.45 249.124L447.748 249.872L445.963 231.918L453.664 231.153L453.919 233.72L449.04 234.197L449.533 239.212Z",
    fill: "#263238"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M457.046 231.017L461.534 231.119C464.357 231.119 465.717 232.819 465.649 235.676L465.428 244.805C465.428 247.695 463.932 249.225 461.109 249.157L456.621 249.055L457.046 231.017ZM459.817 233.669L459.511 246.539H461.109C462.01 246.539 462.571 246.097 462.605 244.839L462.827 235.455C462.827 234.162 462.317 233.754 461.415 233.669H459.817Z",
    fill: "#263238"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M468.864 231.595L471.686 231.935L469.527 249.855L466.705 249.514L468.864 231.595Z",
    fill: "#263238"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M477.652 232.955L474.677 246.556C474.405 247.831 474.864 248.392 475.748 248.596C476.632 248.8 477.278 248.443 477.55 247.185L480.525 233.584L483.143 234.145L480.202 247.576C479.59 250.399 477.839 251.691 475.102 251.096C472.365 250.501 471.328 248.579 471.94 245.757L474.864 232.343L477.652 232.955Z",
    fill: "#263238"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M488.042 249.259L494.434 237.988L498.124 239.399L491.646 256.247L489.147 255.278L493.788 243.207L487.311 254.581L484.812 253.612L487.43 240.946L482.839 252.847L480.527 251.963L487.005 235.114L490.694 236.525L488.042 249.259Z",
    fill: "#263238"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M520.547 280.763L518.949 278.434L533.825 268.233L535.423 270.562L529.048 274.931L530.867 277.6L537.242 273.231L538.943 275.611L524.067 285.812L522.366 283.432L528.742 279.046L526.957 276.461L520.547 280.763Z",
    fill: "#263238"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M540.557 278.587L541.917 281.069L526.089 289.756L524.729 287.257L540.557 278.587Z",
    fill: "#263238"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M537.837 291.133L539.418 294.789L534.147 297.05C531.495 298.189 529.421 297.509 528.316 294.959C527.211 292.409 528.163 290.419 530.798 289.28L539.418 285.574C542.087 284.418 544.161 285.098 545.266 287.648C546.371 290.198 545.419 292.188 542.767 293.327L541.152 294.024L540.098 291.558L541.798 290.793C542.971 290.283 543.192 289.569 542.852 288.753C542.512 287.937 541.815 287.597 540.625 288.107L531.682 291.949C530.492 292.46 530.288 293.174 530.645 293.99C531.002 294.806 531.665 295.163 532.838 294.653L535.899 293.344L535.389 292.154L537.837 291.133Z",
    fill: "#263238"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M531.376 302.626L530.594 299.906L547.969 295.01L548.734 297.73L541.287 299.838L542.172 302.932L549.601 300.841L550.383 303.612L533.025 308.509L532.243 305.737L539.689 303.629L538.805 300.535L531.376 302.626Z",
    fill: "#263238"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M407.693 244.125L418.064 260.888",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M520.938 248.919L508.986 264.867",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M515.753 293.922L472.791 302.371L485.117 325.204L515.753 293.922Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M153.406 648.346H140.281V652.715H153.406V648.346Z",
    fill: "#41525B",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M170.9 648.346H157.775V652.715H170.9V648.346Z",
    fill: "#41525B",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M188.379 648.346H175.254V652.715H188.379V648.346Z",
    fill: "#41525B",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M205.871 648.346H192.746V652.715H205.871V648.346Z",
    fill: "#41525B",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M223.367 648.346H210.242V652.715H223.367V648.346Z",
    fill: "#41525B",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M240.861 648.346H227.736V652.715H240.861V648.346Z",
    fill: "#41525B",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M258.355 648.346H245.23V652.715H258.355V648.346Z",
    fill: "#41525B",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M275.848 648.346H262.723V652.715H275.848V648.346Z",
    fill: "#41525B",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M293.344 648.346H280.219V652.715H293.344V648.346Z",
    fill: "#41525B",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M310.838 648.346H297.713V652.715H310.838V648.346Z",
    fill: "#41525B",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M328.332 648.346H315.207V652.715H328.332V648.346Z",
    fill: "#41525B",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M345.826 648.346H332.701V652.715H345.826V648.346Z",
    fill: "#41525B",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M363.32 648.346H350.195V652.715H363.32V648.346Z",
    fill: "#41525B",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M380.814 648.346H367.689V652.715H380.814V648.346Z",
    fill: "#41525B",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M398.291 648.346H385.166V652.715H398.291V648.346Z",
    fill: "#41525B",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M415.785 648.346H402.66V652.715H415.785V648.346Z",
    fill: "#41525B",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M433.281 648.346H420.156V652.715H433.281V648.346Z",
    fill: "#41525B",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M450.775 648.346H437.65V652.715H450.775V648.346Z",
    fill: "#41525B",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M468.268 648.346H455.143V652.715H468.268V648.346Z",
    fill: "#41525B",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M485.764 648.346H472.639V652.715H485.764V648.346Z",
    fill: "#41525B",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M503.258 648.346H490.133V652.715H503.258V648.346Z",
    fill: "#41525B",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M512.795 653.344H133.498V667.489H512.795V653.344Z",
    fill: "#41525B",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M512.794 653.344H420.273V667.489H512.794V653.344Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M688.263 595.098C688.263 595.098 643.21 515.991 653.615 495.879C664.019 475.767 690.558 511.962 690.558 511.962C690.558 511.962 667.471 438.228 680.17 406.062C692.87 373.895 714.819 406.062 715.975 428.843C717.131 451.625 711.351 490.524 711.351 490.524C711.351 490.524 720.582 410.074 742.531 434.216C764.479 458.357 714.819 538.79 714.819 538.79C714.819 538.79 748.311 520.089 747.121 544.145C745.931 568.202 706.692 589.726 706.692 589.726",
    fill: "url(#paint4_linear_2157_4693)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M688.637 580.341C688.637 580.341 646.967 541.459 667.266 524.033C687.565 506.607 698.259 542.734 698.259 542.734C698.259 542.734 675.818 431.461 712.149 427.432C748.481 423.403 721.772 523.965 721.772 523.965C721.772 523.965 752.765 481.071 750.674 515.923C748.583 550.776 702.577 580.273 702.577 580.273",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M709.107 573.268L680.936 542.751",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M703.24 575.615L710.874 486.409",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M702.068 569.154L727.298 535.713",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M734.319 667.489L738.569 562.932H660.652L664.903 667.489H734.319Z",
    fill: "#263238"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M766.671 667.489H20.3184",
    stroke: "#263238",
    strokeWidth: 0.94526,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2157_4693",
    x1: 411.634,
    y1: 42.5681,
    x2: 530.046,
    y2: 102.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2157_4693",
    x1: 408.358,
    y1: 431.683,
    x2: 418.015,
    y2: 488.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2157_4693",
    x1: 336.611,
    y1: 269.618,
    x2: 588.552,
    y2: 249.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2157_4693",
    x1: 396.015,
    y1: 298.266,
    x2: 517.235,
    y2: 288.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2157_4693",
    x1: 676.384,
    y1: 365.819,
    x2: 811.575,
    y2: 420.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage1);
export default __webpack_public_path__ + "static/media/Image 1.d3aa10a1e7732d6fdc2ee79c52bc6be3.svg";
export { ForwardRef as ReactComponent };